
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-salem",
      function () {
        return require("private-next-pages/tnpsc-salem/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-salem"])
      });
    }
  